module.exports = __webpack_public_path__ + "static/coal-4b0e7847172a0e6ea5386e9eb8d28478.jpg";